import React, { Component } from 'react';
import { BASE_URL, PATHS} from '../properties';
import { connect } from 'react-redux';
import { setHistory, okButton } from '../redux/actions';
import { SERVICES } from '../properties';
import { obtenerFondo, openTip, closeTip } from '../utils';
import Chart from 'react-apexcharts'
import M from 'materialize-css';
import Reload from './reload';
import moment from 'moment';
import axios from 'axios';
import 'moment/locale/es';

import Operaciones from '../components/operaciones';

class FondosInversionTemp extends Component {

    state = {
        infoFondos: false,
        infoSelected: false,
        info: false,
        contrato: null,
        esEmpty: false,
        fondosActivos: false,
        fondoSelected: false

    }


    componentDidMount() {
        this.getInfoFondos();
    }

    separarOperaciones = (data) => {
        const operaciones = (data && data.operaciones) || [];
        const venta = operaciones.find(op => op.tipo === "venta") || null;
        const compra = operaciones.find(op => op.tipo === "compra") || null;

        if (venta && (venta.abierto === undefined || venta.abierto === null || venta.abierto === '')) {
            venta.abierto = 'False';
        }
        if (compra && (compra.abierto === undefined || compra.abierto === null || compra.abierto === '')) {
            compra.abierto = 'False';
        }

        return { venta, compra };
    }

    makeInfoShart = async (fondo, inf) => {

        let configFondo = null;
        try {
            const nombreFondo = (fondo.nombreDelFondo || '').trim();
            configFondo = await obtenerFondo(nombreFondo);

            const seriesConfig = (configFondo && configFondo.series) || [];

            if (configFondo && (seriesConfig.includes(inf.serie) || seriesConfig.length === 0)) {
                // Dar prioridad a los datos de Firebase si existen
                inf = {
                    ...inf,
                    TipoGestion: (configFondo.TipoGestion !== undefined && configFondo.TipoGestion !== '') ? configFondo.TipoGestion : inf.TipoGestion,
                    Plazo: (configFondo.Plazo !== undefined && configFondo.Plazo !== '') ? configFondo.Plazo : inf.Plazo,
                    liquidez: (configFondo.liquidez !== undefined && configFondo.liquidez !== '') ? configFondo.liquidez : (inf.liquidez || inf.Liquidacion || ''),
                    Descripcion: (configFondo.Descripcion !== undefined && configFondo.Descripcion !== '') ? configFondo.Descripcion : inf.Descripcion,
                    HApertura: inf.HApertura || configFondo.HApertura || '',
                    HCierre: inf.HCierre || configFondo.HCierre || '',
                    CpaAbierta: configFondo.CpaAbierta !== undefined ? configFondo.CpaAbierta : inf.CpaAbierta,
                    VtaAbierta: configFondo.VtaAbierta !== undefined ? configFondo.VtaAbierta : inf.VtaAbierta,
                    FondoAbierto: configFondo.FondoAbierto !== undefined ? configFondo.FondoAbierto : inf.FondoAbierto,
                };

                // Integrar operaciones (Compra / Venta): prioriza lo que trae el servicio
                // y solo usa Firebase cuando el servicio no trae el dato
                let operaciones = inf.operaciones ? [...inf.operaciones] : [];
                let opCompra = operaciones.find(op => op.tipo === "compra");
                let opVenta = operaciones.find(op => op.tipo === "venta");

                if (!opCompra) {
                    operaciones.push({
                        tipo: 'compra',
                        apertura: inf.apertura || inf.HApertura || configFondo.HApertura || '',
                        cierre: inf.cierre || inf.HCierre || configFondo.HCierre || '',
                        abierto: configFondo.CpaAbierta !== undefined
                            ? (configFondo.CpaAbierta ? 'TRUE' : 'FALSE')
                            : 'False',
                        compraAnticipada: 'False'
                    });
                } else {
                    if (opCompra.abierto === undefined || opCompra.abierto === null || opCompra.abierto === '') {
                        opCompra.abierto = configFondo.CpaAbierta !== undefined
                            ? (configFondo.CpaAbierta ? 'TRUE' : 'FALSE')
                            : 'False';
                    }
                    opCompra.apertura = opCompra.apertura || inf.apertura || inf.HApertura || configFondo.HApertura || '';
                    opCompra.cierre = opCompra.cierre || inf.cierre || inf.HCierre || configFondo.HCierre || '';
                }

                if (!opVenta) {
                    operaciones.push({
                        tipo: 'venta',
                        apertura: inf.apertura || inf.HApertura || configFondo.HApertura || '',
                        cierre: inf.cierre || inf.HCierre || configFondo.HCierre || '',
                        abierto: configFondo.VtaAbierta !== undefined
                            ? (configFondo.VtaAbierta ? 'TRUE' : 'FALSE')
                            : 'False',
                        ventaAnticipada: 'False'
                    });
                } else {
                    if (opVenta.abierto === undefined || opVenta.abierto === null || opVenta.abierto === '') {
                        opVenta.abierto = configFondo.VtaAbierta !== undefined
                            ? (configFondo.VtaAbierta ? 'TRUE' : 'FALSE')
                            : 'False';
                    }
                    opVenta.apertura = opVenta.apertura || inf.apertura || inf.HApertura || configFondo.HApertura || '';
                    opVenta.cierre = opVenta.cierre || inf.cierre || inf.HCierre || configFondo.HCierre || '';
                }

                inf.operaciones = operaciones;
            }

        } catch (error) {
            console.error("Error al obtener la configuración del fondo:", error);
        }
   
        let { precioAnual } = inf;
        let d = [];
        let cat = [];

        if (precioAnual && precioAnual.length) {
            precioAnual.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
        }

        const preciosGrafica = [...(precioAnual || [])].sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        for (let pm of preciosGrafica) {
            d.push(pm.precio);
            cat.push(moment(pm.fecha).locale('es').format('DD-MMM-YY'));
        }

        if (d.length && cat.length) {

            this.setState({

                series: [{
                    name: "Precio",
                    data: d
                }],
                options: {
                    chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                            enabled: false
                        },
                        toolbar: {
                            export: {
                                csv: {
                                    headerCategory: 'Fecha'
                                }
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        },
                    },
                    xaxis: {
                        categories: cat,
                        labels: {
                            show: true,
                            rotate: -45,
                            rotateAlways: true,
                        }
                    }
                },
                info: { ...inf, operaciones: this.separarOperaciones(inf), nombreFondo: fondo.nombreDelFondo, configFondo },
                fondo: fondo

            });
        }
    }



    componentDidMount = async () => {

        this.props.setHistory(this.props.history);
        try {
            this.getInfoFondos();
            M.Modal.init(document.querySelectorAll('.model_operacion'), {
                dismissible: false
            });
        } catch (error) {

        }
    }


    formatearFecha = () => {

        const fecha = new Date();
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, '0'); // los meses van de 0 a 11
        const day = String(fecha.getDate()).padStart(2, '0');
        return  `${year}-${month}-${day}`; // "2025-12-18"//`${year}-${month}-${day}`;
    }

    formatearInfoFondos = (rawResponse) => {
        if (!rawResponse) return [];

        // Si ya viene con la primera estructura (es un arreglo)
        if (Array.isArray(rawResponse)) {
            return rawResponse;
        }

        let dataPayload = rawResponse;
        if (rawResponse.data) {
            if (Array.isArray(rawResponse.data)) {
                return rawResponse.data;
            }
            dataPayload = rawResponse.data;
        }

        // Si no tiene TTINFOFONDOS, verificar si dataPayload es un arreglo
        const ttInfoFondosObj = dataPayload && dataPayload.TTINFOFONDOS;
        if (!ttInfoFondosObj) {
            return Array.isArray(dataPayload) ? dataPayload : [];
        }

        const rawInfoFondos = ttInfoFondosObj['TT-INFOFONDOS'] || ttInfoFondosObj['TTINFOFONDOS'] || [];
        const ttPreciosObj = (dataPayload && dataPayload.TTPRECIOSMES) || {};
        const rawPreciosMes = ttPreciosObj['TT-PRECIOSMES'] || ttPreciosObj['TTPRECIOSMES'] || ttPreciosObj['TT-PRECIOS-MES'] || [];

        // Agrupar precios por Fondo
        const preciosByFondo = {};
        for (const p of rawPreciosMes) {
            const fondoKey = (p.Fondo || '').trim();
            if (!preciosByFondo[fondoKey]) {
                preciosByFondo[fondoKey] = [];
            }
            preciosByFondo[fondoKey].push(p);
        }

        // Agrupar infoFondos por Fondo y Serie/Tipo
        const fondosMap = new Map();
        for (const item of rawInfoFondos) {
            const fondoName = (item.Fondo || '').trim();
            if (!fondosMap.has(fondoName)) {
                fondosMap.set(fondoName, new Map());
            }
            const seriesMap = fondosMap.get(fondoName);
            const serieName = (item.Tipo || item.serie || '').trim();
            if (!seriesMap.has(serieName)) {
                seriesMap.set(serieName, {
                    infoRows: [],
                    operaciones: []
                });
            }
            const serieData = seriesMap.get(serieName);
            serieData.infoRows.push(item);

            const operacionTipo = (item.Operacion || item.tipo || '').trim().toLowerCase();
            const isCompra = operacionTipo === 'compra';
            const isVenta = operacionTipo === 'venta';

            if (isCompra || !operacionTipo) {
                let abiertoCpaStr;
                if (item.abierto !== undefined && item.abierto !== null && String(item.abierto) !== '') {
                    abiertoCpaStr = String(item.abierto).toUpperCase() === 'TRUE' ? 'True' : 'False';
                } else if (item.CpaAbierta !== undefined && item.CpaAbierta !== null && String(item.CpaAbierta) !== '') {
                    const isAbierto = item.CpaAbierta === 1 || item.CpaAbierta === '1' || String(item.CpaAbierta).toLowerCase() === 'true';
                    abiertoCpaStr = isAbierto ? 'True' : 'False';
                }
                serieData.operaciones.push({
                    tipo: 'compra',
                    apertura: item.apertura || item.HApertura || '',
                    cierre: item.cierre || item.HCierre || '',
                    abierto: abiertoCpaStr,
                    compraAnticipada: item.compraAnticipada !== undefined
                        ? (String(item.compraAnticipada).toUpperCase() === 'TRUE' ? 'True' : 'False')
                        : 'False'
                });
            }

            if (isVenta || !operacionTipo) {
                let abiertoVtaStr;
                if (item.abierto !== undefined && item.abierto !== null && String(item.abierto) !== '') {
                    abiertoVtaStr = String(item.abierto).toUpperCase() === 'TRUE' ? 'True' : 'False';
                } else if (item.VtaAbierta !== undefined && item.VtaAbierta !== null && String(item.VtaAbierta) !== '') {
                    const isAbierto = item.VtaAbierta === 1 || item.VtaAbierta === '1' || String(item.VtaAbierta).toLowerCase() === 'true';
                    abiertoVtaStr = isAbierto ? 'True' : 'False';
                }
                serieData.operaciones.push({
                    tipo: 'venta',
                    apertura: item.apertura || item.HApertura || '',
                    cierre: item.cierre || item.HCierre || '',
                    abierto: abiertoVtaStr,
                    ventaAnticipada: item.ventaAnticipada !== undefined
                        ? (String(item.ventaAnticipada).toUpperCase() === 'TRUE' ? 'True' : 'False')
                        : 'False'
                });
            }
        }

        // Construir la estructura 1 esperada
        const result = [];

        for (const [fondoName, seriesMap] of fondosMap.entries()) {
            const fondoPrecios = preciosByFondo[fondoName] || [];
            const tipos = Array.from(seriesMap.keys());

            const hasExplicitTipo = fondoPrecios.some(p => p.Tipo || p.serie || p.Serie);
            const preciosBySerieName = {};

            if (hasExplicitTipo) {
                for (const p of fondoPrecios) {
                    const sName = (p.Tipo || p.serie || p.Serie || '').trim();
                    if (!preciosBySerieName[sName]) preciosBySerieName[sName] = [];
                    preciosBySerieName[sName].push({
                        fecha: p.Fecha || p.fecha,
                        precio: p.Precio !== undefined ? p.Precio : (p.precio !== undefined ? p.precio : 0)
                    });
                }
            } else {
                const chunks = [];
                let curChunk = [];
                for (let i = 0; i < fondoPrecios.length; i++) {
                    const p = fondoPrecios[i];
                    const prev = curChunk.length > 0 ? curChunk[curChunk.length - 1] : null;
                    if (prev && new Date(p.Fecha || p.fecha) > new Date(prev.Fecha || prev.fecha)) {
                        chunks.push(curChunk);
                        curChunk = [];
                    }
                    curChunk.push(p);
                }
                if (curChunk.length > 0) chunks.push(curChunk);

                tipos.forEach((tName, idx) => {
                    const rawChunk = chunks[idx] || [];
                    preciosBySerieName[tName] = rawChunk.map(p => ({
                        fecha: p.Fecha || p.fecha,
                        precio: p.Precio !== undefined ? p.Precio : (p.precio !== undefined ? p.precio : 0)
                    }));
                });
            }

            const grupoSeries = [];
            for (const [serieName, serieData] of seriesMap.entries()) {
                const baseInfo = serieData.infoRows[0] || {};
                const precioAnual = (preciosBySerieName[serieName] || []).sort(
                    (a, b) => new Date(b.fecha) - new Date(a.fecha)
                );

                grupoSeries.push({
                    serie: serieName,
                    precioAnual,
                    operaciones: serieData.operaciones,
                    HApertura: baseInfo.HApertura || baseInfo.apertura || '',
                    HCierre: baseInfo.HCierre || baseInfo.cierre || '',
                    TipoGestion: baseInfo.TipoGestion || '',
                    Plazo: baseInfo.Plazo || '',
                    Liquidacion: baseInfo.Liquidacion || '',
                    Clasificacion: baseInfo.Clasificacion || '',
                    Descripcion: baseInfo.Descripcion || '',
                    PrecioMD: baseInfo.PrecioMD || 0,
                    Precio24: baseInfo.Precio24 || 0,
                    Precio48: baseInfo.Precio48 || 0
                });
            }

            result.push({
                nombreDelFondo: fondoName,
                grupoSeries
            });
        }

        return result;
    }

    getInfoFondos = async () => {
        try {
       
            const configRequest = {
                url: `${SERVICES.FONDOS_ACTIVOS.url}/${this.formatearFecha()}`,
                method: SERVICES.FONDOS_ACTIVOS.method,
                baseURL: BASE_URL
            }

            let result = await axios.request(configRequest);

            const payload = result && result.data ? (result.data.data || result.data) : null;
            const fondos = this.formatearInfoFondos(payload);

            if (fondos && fondos.length) {
                this.setState({ fondosActivos: fondos }, () => {
                    const fondo = fondos[0];
                    let info = fondo.grupoSeries && fondo.grupoSeries[0];
                    if (info) {
                        info = { ...info, nombreFondo: fondo.nombreDelFondo };
                        this.makeInfoShart(fondo, info);
                    }
                });
            } else {
                this.props.okButton({
                    message: "Por el momento no se encontró información", title: "Información de fondos", txtButton: "Entendido",
                    statusCode: 404,
                    actionClick: async () => {
                    try {
                        this.props.history.push(PATHS.INICIO);
                    } catch (error) {

                    }
                }
                });
            }

            closeTip();

        } catch (error) {
            this.props.okButton({
                message: "Ocurrió un error inesperado intente de nuevo.", title: "Advertencia", txtButton: "Entendido",
                statusCode: 404,
                  actionClick: async () => {
                    try {
                        this.props.history.push(PATHS.INICIO);
                    } catch (error) {

                    }
                }
            });
        } finally {
            setTimeout(()=>{
                closeTip();
            }, 1500)
            
        }
    }





    render() {

        let { fondo, info, fondosActivos } = this.state;

        const clasificacion = info ? (info.Clasificacion || (info.configFondo && (info.configFondo.Clasificacion || info.configFondo.TipoClasificacion)) || '') : '';
        const tipoGestion = info ? (info.TipoGestion || '') : '';
        const horizonte = info ? (info.Plazo || '') : '';
        const liquidez = info ? (info.liquidez || '') : '';

        const camposInfo = [
            { label: 'Clasificación', valor: clasificacion },
            { label: 'Tipo de gestión', valor: tipoGestion },
            { label: 'Horizonte de Inversión', valor: horizonte },
            { label: 'Liquidez', valor: liquidez }
        ].filter(item => item.valor && String(item.valor).trim() !== '');

        const colSize = camposInfo.length > 0 ? Math.floor(12 / camposInfo.length) : 3;

        console.log(info);

        return (
            <div className="row">
                <div className="col s12 m4 l4 xl4">
                    <div className="row">
                        <div className="col s12 closeModalOk center-align boldText ft-20 titleFondos">
                            Información de fondos
                        </div>
                        {
                            fondosActivos ?
                                <div className="col s12 contentInfoFondos" style={{
                                    paddingLeft: '0',
                                    paddingRight: '0'
                                }}>

                                    {
                                        fondosActivos.map((fondo, index) => {

                                            return (
                                                <React.Fragment key={index}>
                                                    <div className={`col s12`} style={{
                                                        textTransform: 'capitalize',
                                                        background: "#41BBC9",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                        marginBottom: '0px !important',
                                                        marginTop: '0px !important',
                                                        paddingBottom: "10px",
                                                        paddingTop: "10px",
                                                        borderBottom: "1px solid"
                                                    }}
                                                        onClick={() => {

                                                            const fondoSelected = fondo.nombreDelFondo !== this.state.fondoSelected ? fondo.nombreDelFondo : false;

                                                            this.setState({
                                                                fondoSelected
                                                            });
                                                        }}
                                                    >
                                                        {fondo.nombreDelFondo}
                                                        <span className='right'><i className='material-icons'>{
                                                            this.state.fondoSelected === fondo.nombreDelFondo ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                                                        }</i></span>
                                                    </div>
                                                    {
                                                        this.state.fondoSelected === fondo.nombreDelFondo &&
                                                        fondo.grupoSeries.map((inf, j) => {

                                                            return (
                                                                <div className={`col s12 infoIRow cursorPointer`} key={j}
                                                                    onClick={() => {
                                                                        this.makeInfoShart(fondo, inf);
                                                                    }}>
                                                                    <div className="row ">
                                                                        <div className="col s6 left-align">
                                                                            Serie: {inf.serie}
                                                                        </div>
                                                                        <div className="col s6 right-align">
                                                                            {inf.precioAnual.length ? `$${inf.precioAnual[0].precio}` : 'N/A'}
                                                                            <span className='right'><i className='material-icons'>keyboard_arrow_right</i></span>
                                                                        </div>
                                                                        <div className="col s6 left-align">
                                                                            <label>Operación Diaria</label>
                                                                        </div>
                                                                        <div className="col s6 right-align">
                                                                            <label>Largo Plazo</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </React.Fragment>
                                            )

                                        })
                                    }

                                </div> : null

                        }

                    </div>
                </div>
                <div className="col s12 m8 l8 xl8" id="chart">
                    {
                        info ?
                            <div className="row mt-1">
                                <div className='col s12 borderLeftInfoFondo ml-1-4'>
                                    <h4 className='boldText'>{info.nombreFondo}</h4>
                                </div>
                                {
                                    (info.Descripcion || (info.configFondo && info.configFondo.Descripcion)) ? (
                                        <div className='col s11 ml-1-4 mt-1'>
                                            <p>{info.Descripcion || (info.configFondo && info.configFondo.Descripcion)}</p>
                                        </div>
                                    ) : null
                                }
                                
                                <div className='col s12 borderLeftInfoFondo ml-1-4 mt-1'>
                                    <h4 className='boldText'>Serie {info.serie}</h4>
                                </div>
                                <div className='col s12 ml-1-4 mt-1'>
                                    <div className='row'>
                                        <div className='col s6'>
                                            <h5>Último precio conocido</h5>
                                            <div>(Valor mercado, mismo día)</div>
                                        </div>
                                        <div className='col s6'>
                                            <h4>${info.precioAnual[0].precio}</h4>
                                        </div>
                                    </div>
                                </div>

                                <div className="col s12">
                                    <Chart options={this.state.options} series={this.state.series} type="line" height={350} />
                                </div>

                                <div className="col s12 mt-1">
                                    <div className="row  contentInfoFondo">
                                        {camposInfo.map((item, idx) => (
                                            <div className={`col s${colSize} borderLeftInfoFondo`} key={idx}>
                                                <div><label style={{ color: '#41BBC9' }}>{item.label}</label></div>
                                                <div>{item.valor}</div>
                                            </div>
                                        ))}

                                        <div className='col s12 divider mt-1'>

                                        </div>

                                        <div className='col s12 center-align'>
                                            <h4 style={{ color: '#41BBC9', fontWeight: 'bold' }}>Tipo de Operación</h4>
                                        </div>

                                        <div className='col s12'>
                                            <div className='row'>
                                                <div className='col s12 m6' style={{ paddingRight: '2rem' }}>
                                                    <div className='row'>
                                                        <div className='col s12 center-align'>
                                                            <h5 style={{ color: '#41BBC9', fontWeight: 'bold' }}>Compra</h5>
                                                        </div>
                                                        <div className='col s6'>
                                                            <p>
                                                                <label>
                                                                    <input type="checkbox" className="filled-in" checked={
                                                                        info.operaciones && info.operaciones.compra && String(info.operaciones.compra.abierto).toUpperCase() === 'TRUE' ? true : false
                                                                    } />
                                                                    <span>Abierta</span>
                                                                </label>
                                                            </p>
                                                        </div>
                                                        <div className='col s6'>
                                                            <p>
                                                                <label>
                                                                    <input type="checkbox" className="filled-in" checked={
                                                                        info.operaciones && info.operaciones.compra && String(info.operaciones.compra.abierto).toUpperCase() === 'FALSE' ? true : false
                                                                    } />
                                                                    <span>Cerrada</span>
                                                                </label>
                                                            </p>
                                                        </div>
                                                        <div className='col s12 divider mt-1 mb-1'>
                                                        </div>
                                                        <div className="col s6 borderLeftInfoFondo">
                                                            <div><label style={{ color: '#41BBC9' }}>Hora de Apertura</label></div>
                                                            <div>{info.operaciones.compra?.apertura || ''}</div>
                                                        </div>

                                                        <div className="col s6 borderLeftInfoFondo">
                                                            <div><label style={{ color: '#41BBC9' }}>Hora de Cierre</label></div>
                                                            <div>{info.operaciones.compra?.cierre || ''}</div>
                                                        </div>

                                                        <div className='col s12 ft-10 mt-1'>
                                                            <i className='material-icons left' style={{
                                                                fontSize: "16px",
                                                                marginRight: "1px",
                                                                color: '#666666'
                                                            }}>info_outline</i>
                                                            Horario de la Ciudad de México (GMT-6).
                                                        </div>
                                                        <div className='col s12 divider mt-1 mb-1'>
                                                        </div>
                                                        <div className='col s6'>
                                                            <span style={{ color: '#41BBC9', fontWeight: 'bold' }}>Compra anticipada</span>
                                                        </div>
                                                        <div className='col s6'>
                                                            <label style={{ marginLeft: '.5 rem' }}>
                                                                <input type="checkbox" className="filled-in" checked={
                                                                    info.operaciones && info.operaciones.compra && String(info.operaciones.compra.compraAnticipada).toUpperCase() === 'TRUE' ? true : false
                                                                } />
                                                                <span>Sí</span>
                                                            </label>
                                                            <label style={{ marginLeft: '.5rem' }}>
                                                                <input type="checkbox" className="filled-in" checked={
                                                                    info.operaciones && info.operaciones.compra && String(info.operaciones.compra.compraAnticipada).toUpperCase() === 'FALSE' ? true : false
                                                                } />
                                                                <span>No</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>


                                                {/** Venta */}
                                                <div className='col s12 m6' style={{ paddingLeft: '2rem' }}>
                                                    <div className='row'>
                                                        <div className='col s12 center-align'>
                                                            <h5 style={{ color: '#41BBC9', fontWeight: 'bold' }}>Venta</h5>
                                                        </div>
                                                        <div className='col s6'>
                                                            <p>
                                                                <label>
                                                                    <input type="checkbox" className="filled-in" checked={
                                                                        info.operaciones && info.operaciones.venta && String(info.operaciones.venta.abierto).toUpperCase() === 'TRUE' ? true : false
                                                                    } />
                                                                    <span>Abierta</span>
                                                                </label>
                                                            </p>
                                                        </div>
                                                        <div className='col s6'>
                                                            <p>
                                                                <label>
                                                                    <input type="checkbox" className="filled-in" checked={
                                                                        info.operaciones && info.operaciones.venta && String(info.operaciones.venta.abierto).toUpperCase() === 'FALSE' ? true : false
                                                                    } />
                                                                    <span>Cerrada</span>
                                                                </label>
                                                            </p>
                                                        </div>
                                                        <div className='col s12 divider mt-1 mb-1'>
                                                        </div>
                                                        <div className="col s6 borderLeftInfoFondo">
                                                            <div><label style={{ color: '#41BBC9' }}>Hora de Apertura</label></div>
                                                            <div>{info.operaciones.venta?.apertura || ''}</div>
                                                        </div>

                                                        <div className="col s6 borderLeftInfoFondo">
                                                            <div><label style={{ color: '#41BBC9' }}>Hora de Cierre</label></div>
                                                            <div>{info.operaciones.venta?.cierre || ''}</div>
                                                        </div>

                                                        <div className='col s12 ft-10 mt-1'>
                                                            <i className='material-icons left' style={{
                                                                fontSize: "16px",
                                                                marginRight: "1px",
                                                                color: '#666666'
                                                            }}>info_outline</i>
                                                            Horario de la Ciudad de México (GMT-6).
                                                        </div>
                                                        <div className='col s12 divider mt-1 mb-1'>
                                                        </div>

                                                        <div className='col s6'>
                                                            <span style={{ color: '#41BBC9', fontWeight: 'bold' }}>Venta anticipada</span>
                                                        </div>
                                                        <div className='col s6'>
                                                            <label style={{ marginLeft: '.5 rem' }}>
                                                                <input type="checkbox" className="filled-in" checked={
                                                                    info.operaciones && info.operaciones.venta?.ventaAnticipada.toUpperCase() === 'TRUE' ? true : false
                                                                } />
                                                                <span>Sí</span>
                                                            </label>
                                                            <label style={{ marginLeft: '.5rem' }}>
                                                                <input type="checkbox" className="filled-in" checked={
                                                                    info.operaciones && info.operaciones.venta?.ventaAnticipada.toUpperCase() === 'FALSE' ? true : false
                                                                } />
                                                                <span>No</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>

                            </div>

                            : null}

                </div>
                <Operaciones />
            </div>
                )

    }
}


const mapStateToProps = state => {
                    let {dataUser, currentContrato, menuPerfil, contratosUser,
                        chequera, history
                } = false;
                if (state.servicesActions) {
                    dataUser = state.servicesActions.dataUser || false;
                currentContrato = state.servicesActions.currentContrato || false
                contratosUser = state.servicesActions.contratosUser || false
                chequera = state.servicesActions.chequera || false
    }

                if (state.commonsActions) {
                    menuPerfil = state.commonsActions.menuPerfil || false;
                history = state.commonsActions.history || false;
    }

                return {dataUser, currentContrato, menuPerfil, contratosUser, chequera, history};
};

                export default connect(mapStateToProps,
                {
                    setHistory,
                    okButton
                }
                )(FondosInversionTemp)